import * as bannersActions from './banners.actions';
import { createReducer, on } from '@ngrx/store';
import { BannerMessage } from '../banners.model';

export interface BannersState {
    banners: BannerMessage[];
}
export const BANNERS_FEATURE_KEY = 'Banners';
export const bannersInitialState: BannersState = {
    banners: []
};
export const bannersReducer = createReducer(
    bannersInitialState,
    on(bannersActions.getBannersSuccess, (state, { banners }) => ({
        ...state,
        banners
    }))
);
